import { Box, Divider, Grid, useMediaQuery, useTheme } from '@material-ui/core'
import React from 'react'
import {
  ListProps,
  Pagination,
  TextField,
  TextInput,
  Filter,
  FunctionField,
  Datagrid,
  BooleanField,
  EditButton,
  DeleteButton,
  useTranslate,
} from 'react-admin'
import FilterProps from '../../common/FilterProps'
import List from '../../common/customized-ra-components/List'
import { useHasAuthority } from '../../hooks/useHasAuthority'
import { Authority } from '../../../core/auth/Authority'
import { DynamicCounterDto } from '../../../core/dto/dynamic-counter.dto'
import { ResourceName } from '../../../core/ResourceName'

const DynamicCountersFilters = (props: FilterProps) => (
  <Filter {...props}>
    <TextInput source="name" alwaysOn autoFocus />
  </Filter>
)

const DynamicCountersExpand = () => {
  const t = useTranslate()

  return (
    <Box padding={1}>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          {t('resources.dynamic-counters.fields.active')}
        </Grid>
        <Grid item xs={8}>
          <BooleanField source="active" />
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={4}>
          {t('resources.dynamic-counters.fields.state')}
        </Grid>
        <Grid item xs={8}>
          <TextField source="state" />
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={4}>
          {t('resources.dynamic-counters.fields.limit')}
        </Grid>
        <Grid item xs={8}>
          <TextField source="limit" />
        </Grid>
      </Grid>
    </Box>
  )
}

export const DynamicCountersList = (props: ListProps) => {
  const hasAuthority = useHasAuthority()
  const theme = useTheme()
  const largeScreen = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <List
      {...props}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[10, 20, 50, 100, 200]} />}
      exporter={false}
      filters={<DynamicCountersFilters />}
      bulkActionButtons={false}
      sort={{
        field: 'id',
        order: 'DESC',
      }}
    >
      <Datagrid
        size="small"
        padding={!largeScreen ? 'checkbox' : 'default'}
        isRowExpandable={() => !largeScreen}
        expand={<DynamicCountersExpand />}
        rowClick={(id, basePath, record) =>
          `/${ResourceName.DYNAMIC_COUNTERS}/${record?.id}/show`
        }
      >
        hasBulkActions={false}
        <TextField source="id" label="ID" />
        <TextField source="name" />
        {largeScreen && <BooleanField source="active" />}
        {largeScreen && <TextField source="state" sortable={false} />}
        {largeScreen && <TextField source="limit" sortable={false} />}
        {hasAuthority(Authority.EDIT_DYNAMIC_COUNTERS) && largeScreen && (
          <FunctionField<DynamicCounterDto>
            render={(counter?: DynamicCounterDto) => (
              <EditButton record={counter} />
            )}
          />
        )}
        {hasAuthority(Authority.DELETE_DYNAMIC_COUNTERS) && (
          <FunctionField<DynamicCounterDto>
            render={(counter?: DynamicCounterDto) =>
              largeScreen ? (
                <DeleteButton
                  record={counter}
                  undoable={false}
                  resource={ResourceName.DYNAMIC_COUNTERS}
                />
              ) : (
                <DeleteButton
                  record={counter}
                  undoable={false}
                  resource={ResourceName.DYNAMIC_COUNTERS}
                />
              )
            }
          />
        )}
      </Datagrid>
    </List>
  )
}
